import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['¿Alguna vez has querido empezar a hacer jabones artesanales… pero terminaste más confundida que antes?', '¿Has visto videos donde cada persona usa medidas distintas… y nadie explica realmente qué está haciendo?', '¿Compraste materiales… y al mezclarlos se arruinó todo?', '¿Te dio miedo usar soda cáustica porque nadie explica los riesgos de forma clara?', '¿Te gustaría vender… pero no tienes idea de cuánto cobrar ni cómo presentar tus productos?'];
export function PainPoints() {
  return <section className="w-full bg-[var(--bg-dark)] py-20 px-4" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <motion.p className="text-2xl md:text-3xl text-[var(--text-gray)] mb-8 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-92">
          Querida futura emprendedora,
        </motion.p>

        <motion.h2 className="text-3xl md:text-4xl font-bold text-[var(--text-light)] mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} data-id="element-93">
          Déjame preguntarte algo…
        </motion.h2>

        <div className="space-y-6" data-id="element-94">
          {painPoints.map((point, index) => <motion.div key={index} className="bg-[var(--bg-card)] p-6 rounded-lg border-l-4 border-[var(--accent-orange)]" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} data-id="element-95">
              <p className="text-lg md:text-xl text-[var(--text-light)]" data-id="element-96">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="mt-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.6
      }} data-id="element-97">
          <p className="text-2xl md:text-3xl font-bold text-[var(--text-light)] mb-4" data-id="element-98">
            Si asentiste aunque sea a una de estas preguntas…
          </p>
          <p className="text-xl md:text-2xl text-[var(--accent-orange-light)]" data-id="element-99">
            No estás sola.
          </p>
          <p className="text-xl md:text-2xl text-[var(--text-gray)] mt-2" data-id="element-100">
            Y no es tu culpa.
          </p>
        </motion.div>
      </div>
    </section>;
}